/* unplugin-vue-components disabled */import { render } from "./SubjectCard.vue?vue&type=template&id=3f994f36&scoped=true"
import script from "./SubjectCard.vue?vue&type=script&lang=js"
export * from "./SubjectCard.vue?vue&type=script&lang=js"

import "./SubjectCard.vue?vue&type=style&index=0&id=3f994f36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f994f36"]])

export default __exports__